import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = process.env.REACT_APP_API_URL || '/api';

export const subscriptionApi = createApi({
  reducerPath: 'subscriptionApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Subscription'],
  endpoints: (builder) => ({
    // Get current user's subscription
    getMySubscription: builder.query({
      query: () => '/subscriptions/me',
      providesTags: ['Subscription'],
    }),

    // Get subscription by ID
    getSubscription: builder.query({
      query: (id) => `/subscriptions/${id}`,
      providesTags: (result, error, id) => [{ type: 'Subscription', id }],
    }),

    // Get all subscriptions (admin)
    getSubscriptions: builder.query({
      query: (params) => ({
        url: '/subscriptions',
        params,
      }),
      providesTags: ['Subscription'],
    }),

    // Update subscription
    updateSubscription: builder.mutation({
      query: ({ id, ...subscription }) => ({
        url: `/subscriptions/${id}`,
        method: 'PUT',
        body: subscription,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Subscription', id },
        'Subscription',
      ],
    }),

    // Cancel subscription
    cancelSubscription: builder.mutation({
      query: (id) => ({
        url: `/subscriptions/${id}/cancel`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'Subscription', id },
        'Subscription',
      ],
    }),

    // Upgrade subscription
    upgradeSubscription: builder.mutation({
      query: ({ id, ...upgradeData }) => ({
        url: `/subscriptions/${id}/upgrade`,
        method: 'POST',
        body: upgradeData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Subscription', id },
        'Subscription',
      ],
    }),
  }),
});

export const {
  useGetMySubscriptionQuery,
  useGetSubscriptionQuery: useGetSubscriptionByIdQuery,
  useGetSubscriptionsQuery,
  useUpdateSubscriptionMutation,
  useCancelSubscriptionMutation,
  useUpgradeSubscriptionMutation,
} = subscriptionApi;

// For backward compatibility, export useGetMySubscriptionQuery as useGetSubscriptionQuery
export const useGetSubscriptionQuery = useGetMySubscriptionQuery;
